<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <h5><small>Dönemler</small>
      <el-button-group v-if="Bina.ufirma && Bina.ccid" class="float-right" style="margin-top: -2px">
        <el-button @click="MailGonder" size="mini" type="danger">
          Endeks Mail
        </el-button>
        <el-button @click="UzaktanOkumaModalDurum=true" size="mini" type="primary">
          Uzaktan Okuma
        </el-button>
      </el-button-group>
    </h5>

    <table class="table table-xs">
      <thead>
      <tr>
        <th>Dönem Adı</th>
        <th>Eklenme Tarihi</th>
        <th>Durum</th>
        <th class="text-right">Fatura Tutarı</th>
        <th class="text-right">Hacim</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="d in DonemListe" :class="d.Durum=='Tamamlandı'?'':'table-danger'" @click="DetayGetir(d)">
        <td>{{ d.aciklama }}</td>
        <td>{{ d.tarih }}</td>
        <td>{{ d.Durum }}</td>
        <td class="text-right">{{ d.tutar }}<sup>TL</sup></td>
        <td class="text-right">{{ d.hacim }}<sup>kWh</sup></td>
      </tr>
      </tbody>
    </table>
    <UzaktanOkumaModal v-if="UzaktanOkumaModalDurum" :Data="Bina" :Durum="UzaktanOkumaModalDurum"
                       @Durum="UzaktanOkumaModalDurum=false"></UzaktanOkumaModal>
    <el-dialog
      append-to-body
      title="Dönem Detay"
      :visible="Modal"
      v-if="Modal"
      center
      width="100%">

      <a @click="Modal=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <el-button type="primary" size="mini" v-if="!lo" class="float-right borcmodalbuton"
                 @click="SayfaGit(FaturaDetay.id)">Döküm Detayı
      </el-button>
      <BinaHesaplamaDokumu :Fatura="FaturaDetay" :AltToplam="AltToplam" :FaturaDokum="FaturaDokum"></BinaHesaplamaDokumu>

    </el-dialog>
  </div>
</template>

<script>
import Yukleniyor from "../../../Doc/Yukleniyor";
import UzaktanOkumaModal from "../../../../pages/_Sayac/Bina/UzaktanOkumaModal";
import BinaHesaplamaDokumu from "../BinaHesaplamaDokumu";

export default {
  components: {BinaHesaplamaDokumu, UzaktanOkumaModal,  Yukleniyor},
  props: ['Bina', 'Donem', 'Fatura'],
  data() {
    return {
      AktifStep: 1,
      lo: false,
      Modal: false,
      UzaktanOkumaModalDurum: false,
      DonemListe: null,
      FaturaDetay: null,
      AltToplam: null,
      FaturaDokum: null
    }
  },
  methods: {
    SayfaGit(id) {
      this.$router.push("/dokum/" + id)
    },
    DetayGetir(Fatura) {
      if (Fatura.Durum == 'Tamamlandı') {
        this.lo = true;
        this.$store.dispatch("Get", {path: '_enerji/dokum/fatura/' + Fatura.id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.FaturaDetay = response.Fatura;
              this.FaturaDokum = response.FaturaDokum;
              this.AltToplam = response.AltToplam;
              this.lo = false;
              this.Modal = true;
            } else {
              this.$message.error(response.Mesaj);
            }
          });
      } else {
        this.$message.error("Dönem henüz onaylanmamıştır");
      }
    },
    MailGonder() {
      this.$prompt('Gönderilecek mail adreslerini yazınız.', 'Mail Gönder', {
        confirmButtonText: 'Mail Gönder',
        cancelButtonText: 'Vazgeç',
        inputValue: this.Bina.Email,
        inputPlaceholder: 'Mail Adresleri',
        dangerouslyUseHTMLString: true,
      }).then(({value}) => {

        this.MailYolla(value);


      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Mail İptal Edildi'
        });
      });
    },
    MailYolla(Adresler) {
      if (Adresler) {
        this.lo = true;
        this.$store.dispatch("Post", {
          Mail: Adresler,
          Bina_id: this.Bina.id,
          Url: 'https://sendmail.yapifenenerji.net/araokuma.php',
          path: ''
        })
          .then(response => {
            this.lo = false
            if (response == '1') {
              this.$message.success('Mail gönderildi')
            } else {
              this.$message.error('Mail gönderilemedi')
            }
          });
      } else {
        this.$message.error('Mail adresleri boş')
      }

    },
    SayfaYukle() {
      this.$store.dispatch("Get", {path: '_enerji/dokum/bina/' + this.Bina.id})
        .then(response => {
          if (response.Durum === 'OK') {
            this.DonemListe = response.Liste
            this.lo = false
          } else {
            this.$message.error(response.Mesaj);
          }
        });
    },
  },
  created() {
    this.SayfaYukle();
  }
}
</script>

<style scoped>
h5 {
  padding: 5px;
  background: #eceef6;
}

.borcmodalbuton2 {
  position: absolute;
  top: 15px;
  right: 200px;

}

</style>



// WEBPACK FOOTER //
// src/components/Pack/Esayac/Comp/EsayacDonem.vue